var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 116,
    viewBox: "0 0 158 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.973 102.185C142.611 105.272 137.279 107.331 131.626 108.886C100.461 117.458 60.4445 120.833 31.6909 104.188C19.5575 97.1647 12.8416 85.205 14.1648 72.1355C15.4559 59.3978 23.388 53.2475 36.7625 51.2291C66.7537 46.7026 99.3057 45.4733 129.475 49.1975C136.002 50.003 142.793 51.2712 147.843 55.1099C152.433 58.5998 155.022 63.827 156.495 69.0962C158.568 76.4869 158.685 84.4823 155.672 91.6004C153.76 96.1116 150.725 99.5287 146.973 102.185Z",
    fill: "#C1DFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66897 7.82133C3.53397 8.53067 1.25016 11.3901 0.437251 14.453C-3.1443 27.9372 16.089 46.7709 28.4777 47.9297C43.5421 49.339 51.1604 29.1676 54.2371 14.9061C55.4346 9.35784 53.2018 2.64847 47.8213 0.612109C43.0003 -1.21279 37.4813 1.2854 33.8523 4.90184C32.1244 6.62218 30.6171 8.63092 28.4846 9.83401C25.9747 11.2514 22.8725 11.3589 20.0492 10.7311C19.054 10.5096 18.0935 10.1945 17.1493 9.84818C13.7428 8.59846 10.5513 6.94286 6.66897 7.82133Z",
    fill: "#F18273"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7302 43.8986C21.3283 46.1551 24.9801 47.6306 28.1763 47.9295C43.2407 49.3389 50.859 29.1674 53.9357 14.9059C54.7457 11.153 53.9862 6.86874 51.7446 3.85889C51.726 4.00128 51.7072 4.14589 51.6884 4.29273C48.2833 30.8393 24.1658 41.5065 17.7302 43.8986Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/c1.ab638bcfc3d1ef4908be6cc39764d524.svg";
export { ForwardRef as ReactComponent };